"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _uuid = require("uuid");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(donationAmount) {
  var donationAmountInPounds = parseInt(donationAmount, 10) / 100; // Add purchase information to Google DataLayer

  var dataLayer = window.dataLayer || [];
  dataLayer.push({
    ecommerce: null
  }); // Clear previous ecommerce objects.

  dataLayer.push({
    event: 'Purchase',
    ecommerce: {
      purchase: {
        actionField: {
          id: (0, _uuid.v4)(),
          affiliation: 'Website',
          revenue: donationAmountInPounds.toString()
        },
        products: [{
          name: 'One-off donation',
          price: donationAmountInPounds.toString(),
          quantity: 1
        }]
      }
    }
  });
};

exports["default"] = _default;